import { StoreType } from '@tock/shared/utils/connect';
import { core } from '@tock/coretypes';
import { createSelector } from 'reselect';

export const loggedInPatronOptionOrdersSelector = createSelector(
  (state: StoreType) => state.selection.options || [],
  (state: StoreType) => state.app.patron || undefined,
  (optionOrders: core.IOptionOrder[], patron?: core.IPatron) => {
    return optionOrders.filter((option) => option.patron?.id === patron?.id);
  }
);

export const partyOptionOrdersSelector = createSelector(
  (state: StoreType) => state.selection.options || [],
  (state: StoreType) => state.app.patron || undefined,
  (optionOrders: core.IOptionOrder[], patron?: core.IPatron) => {
    return optionOrders.filter((option) => option.patron?.id !== patron?.id);
  }
);

export const loggedInPatronOriginalOptionOrdersSelector = createSelector(
  (state: StoreType) => state.selection.originalOptions || [],
  (state: StoreType) => state.app.patron || undefined,
  (optionOrders: core.IOptionOrder[], patron?: core.IPatron) => {
    return optionOrders.filter((option) => option.patron?.id === patron?.id);
  }
);
